// 工具函数集
import config from '@/utils/config'
//判断是否是iphonex，做对应的特殊处理
export function	isIPhoneX(fn){
		var isIPhoneX;
    var u = navigator.userAgent;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isIOS) {
        if (screen.height == 812 && screen.width == 375){
     			isIPhoneX = true;    //是iphoneX
        }else{
					isIPhoneX = false;    //不是iphoneX
        }
    }
    return isIPhoneX;
}


//上传图片
// formData   ============     let param = new FormData();      param.append('file', req.file,req.file.name);
export function	uploadImg(formData,callback,errback){
  fly.post(config.commonApi + "common/core/uploadObject2OSS",formData)
  .then((res)=> {
      if(res.code == '0000'){
        callback(res);
      }else {
        if(typeof errback == 'function'){
          errback(res)
        }
      }
  })
}



export function hasClass(el, className) {
  let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
  return reg.test(el.className)
}

export function validForm(vmF,callback) {
  vmF.$validator.validateAll().then((result) => {
  if (!result) {
        vmF.$dialog.toast({ mes:vmF.$validator.errors.items[0].msg });
        return false;
      }
        callback()
    });
}

export function addClass(el, className) {
  if (hasClass(el, className)) {
    return
  }

  let newClass = el.className.split(' ')
  newClass.push(className)
  el.className = newClass.join(' ')
}

export function removeClass(el, className) {
  if (!hasClass(el, className)) {
    return
  }

  let reg = new RegExp('(^|\\s)' + className + '(\\s|$)', 'g')
  el.className = el.className.replace(reg, ' ')
}

export function getRect(el) {
  if (el instanceof window.SVGElement) {
    let rect = el.getBoundingClientRect()
    return {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height
    }
  } else {
    return {
      top: el.offsetTop,
      left: el.offsetLeft,
      width: el.offsetWidth,
      height: el.offsetHeight
    }
  }
}

export function formatIndexList (list) {
	const result = []
	delete list.ret_code
	for (let key in list) {
    result.push(list[key]);
  }
  return result
}

const valid = {
  mobile: (value)=>{
    let t, mes;
    if(!value) {
      t = false;
      mes = '请输入手机号码'
    }else if(value.length == 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value)){
      t = true;
    }else {
      t = false;
      mes = '请输入正确的手机号码'
    }
    return {t:t,mes:mes}
  },
  email: (value)=>{
    let t, mes;
    if(!value) {
      t = false;
      mes = '请输入邮箱地址'
    }else if(/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(value)){
      t = true;
    }else {
      t = false;
      mes = '请输入正确的邮箱地址'
    }
    return {t:t,mes:mes}
  }
}
export {
  valid
}



// WEBPACK FOOTER //
// ./src/utils/index.js